module.exports = __webpack_public_path__ + "img/PD1505010672818323456.a3514e0b.png";